<script>
    import { createEventDispatcher } from "svelte";
    import Button from "../ui/Button.svelte";
    import AddStamp from "./AddStamp.svelte";
    import StampItem from "./StampItem.svelte";
    export let stamps;

    const dispatch = createEventDispatcher();

    //get count of active stamps
    let activeStamps = 0;
    stamps.forEach((stamp) => {
        if (stamp.state === "active") {
            activeStamps++;
        }
    });
</script>

<div class="list">
    {#each stamps as stamp (stamp.id)}
        <StampItem bind:stamp on:remove={(e) => dispatch("remove", e.detail)} on:edit={(e) => dispatch("edit", e.detail)}/>
    {/each}
    {#if activeStamps >= 20}
        <p>Du hast die maximale Anzahl an aktiven Stempeln erreicht</p>
    {:else}
        <AddStamp on:add={(e) => dispatch("add", e.detail)}/>
    {/if}
</div>

<style>
    .list {
        display: flex;
        flex-direction: column;
        margin-bottom: 1rem;
    }
</style>